export const state = {
    card_id: null,
};

export default state;
